import { render, staticRenderFns } from "./SearchContent.vue?vue&type=template&id=7c70a4e5&"
import script from "./SearchContent.js?vue&type=script&lang=js&"
export * from "./SearchContent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports